import { render, staticRenderFns } from "./EditPerson.vue?vue&type=template&id=3b447b7e&scoped=true&"
import script from "./EditPerson.vue?vue&type=script&lang=js&"
export * from "./EditPerson.vue?vue&type=script&lang=js&"
import style0 from "./EditPerson.vue?vue&type=style&index=0&id=3b447b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b447b7e",
  null
  
)

export default component.exports